import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class PerguntaApi {
  cancelTokens = {
    getPerguntas: null,
    getPergunta: null,
    setPergunta: null,
    destroyPergunta: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getPerguntas({ page = 1, qtd_por_pagina, texto, ativo }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      texto,
      ativo,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.getPerguntas = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/perguntas?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getPerguntas = null;
    return data;
  }

  async getPergunta(perguntaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.getPergunta = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/perguntas/${perguntaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getPergunta = null;
    return data;
  }

  async destroyPergunta(perguntaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.destroyPergunta = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/perguntas/${perguntaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyPergunta = null;
    return data;
  }

  async setPergunta(pergunta) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.setPergunta = source;

    const dadosParaEnviar = {
      pergunta: {
        texto: pergunta.texto,
        ativo: pergunta.ativo,
      },
    };

    if (pergunta.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/perguntas/${pergunta.id}`,
        dadosParaEnviar,
        { cancelToken: source.token }
      );
      this.cancelTokens.setPergunta = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/perguntas`,
        dadosParaEnviar,
        { cancelToken: source.token }
      );
      this.cancelTokens.setPergunta = null;
      return data;
    }
  }
}

export default PerguntaApi;